import * as types from '../../constants/actionTypes/canvasBlocks';

const initialState = 0;

const capturedActions = {
    // UNDO / REDO
    '@@redux-undo/UNDO': 'pressed undo button.',
    '@@redux-undo/REDO': 'pressed redo button.',
    [types.POPULATE_INITIAL_BLOCKS]: 'Reload or initial load of the blocks',
};

// This reducer will trigger a rerender of CKE. Be careful when adding any action to this
// as it may trigger a cursor jump on re-render of CKE.
const reloadTextEditor = (state = initialState, action) => {
    if (Object.keys(capturedActions).includes(action.type)) {
        return state + 1;
    }
    return state;
};

export default reloadTextEditor;
